import { useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { InstrumentTypeResponse } from "../../../codegen-api";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { OrderHistoryItem } from "../../../interfaces/history";
import { AssetResponse } from "../../../utils/asset";
import {
  useCursorPaginatedHistory,
  UseCursorPaginatedHistoryResult,
} from "./useCursorPaginatedHistory";

interface UseOrderHistoryOptions {
  pageSize?: number;
  instrumentType?: InstrumentTypeResponse;
  /** Server-side filter — only history for this underlying asset. */
  asset?: AssetResponse;
  enabled?: boolean;
}

export const useOrderHistory = ({
  pageSize,
  instrumentType,
  asset,
  enabled = true,
}: UseOrderHistoryOptions = {}): UseCursorPaginatedHistoryResult<OrderHistoryItem> => {
  const { account } = useContext(AuthContext);
  const accountKey = account?.toLowerCase();

  const realtimeChannels = useMemo(
    () => (accountKey ? [`order-history:${accountKey}`] : []),
    [accountKey]
  );

  return useCursorPaginatedHistory<OrderHistoryItem>({
    endpoint: APIEndpointEnum.ORDER_HISTORY,
    itemsKey: "order_history",
    pageSize,
    enabled,
    query: { instrument_type: instrumentType, asset },
    realtimeChannels,
  });
};
